<script>
   /*****************************************************************/
   /* DFPlot for SIMCA results                                      */
   /* ------------------------                                      */
   /* shows plot with number of degrees of freedom vs number of PCs */
   /*****************************************************************/

   import DFPlot from '../../../shared/plots/DFPlot.svelte';

   export let params;                     // JSON with main plot parameters
   export let res;                        // JSON with SIMCA results
   export let ncomp = 1;                  // number of components selected by user
   export let fileName = 'plot-dof';      // file name for saving plots

   /*****************************************/
   /* Component code                        */
   /*****************************************/

   function getPlotData(res) {
      const ncomp = res.v.length;
      const Nh = new Array(ncomp);
      const Nq = new Array(ncomp);
      const x = new Array(ncomp);
      let NhMax = 0;
      let NqMax = 0;
      for (let a = 0; a < ncomp; a++) {
         x[a] = a + 1;
         Nh[a] = res.v[a].Nh;
         Nq[a] = res.v[a].Nq;
         NhMax = Math.max(NhMax, Nh[a]);
         NqMax = Math.max(NqMax, Nq[a]);
      }
      return {ncomp: ncomp, x, Nh, Nq, NhMax, NqMax}
   }

   $: plotseries = res ? getPlotData(res[Object.keys(res)[0]]) : null;
</script>

{#if plotseries }
<DFPlot
   {ncomp}
   {params}
   {plotseries}
   {fileName}
/>
{/if}